import React from "react";

const CardView = ({ children, style, icons }) => {
  const backgroundStyle = icons
    ? {
        height: "100%",
        background: `url(${icons})`,
        backgroundPosition: "bottom right",
        backgroundRepeat: "no-repeat",
        backgroundSize: "20vw",
        minHeight: "10vw",
      }
    : {};

  return (
    <div
      className="d-flex flex-column h-100 w-100 m-auto"
      style={{
        boxShadow: "rgba(0, 0, 0, 0.157) 1px 5px 20px",
        backgroundColor: "white",
        borderRadius: "5px",
        padding: "16px",
        ...style,
        ...backgroundStyle,
      }}
    >
      {children}
    </div>
  );
};

export default CardView;
